import app from 'flarum/common/app';

app.initializers.add('foskym/flarum-better-user-directory', () => {
  console.log('[foskym/flarum-better-user-directory] Hello, forum and admin!');
});
